import Vue from 'vue';
import App from './App.vue';
import router from './router';
import NowUiKit from './plugins/now-ui-kit';
import store from './store';
// VueFileAgent
import VueFileAgent from 'vue-file-agent';
// BootstrapVue add
import BootstrapVue from 'bootstrap-vue';
//Muti
import VueI18n from 'vue-i18n';
// import en from './locales/en.json'
// import vn from './locales/vn.json'
import { defaultLocale, firebaseConfig } from './constants/config';
// Notification Component Add
import Notifications from './components/Notification';
import PrimeVue from 'primevue/config';
import RepositoryFactory from '@/repository/factory';
const authenAndConfigCustomize = RepositoryFactory.get('authenAndConfigCustomize');

Vue.use(PrimeVue);
Vue.use(Notifications);
Vue.use(VueFileAgent);
Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(NowUiKit);
Vue.use(VueI18n);
// const messages = { vn: vn, en: en }
// const locale = localStorage.getItem('currentLanguage') && JSON.parse(localStorage.getItem('listLanguage'))?.length > 0 && JSON.parse(localStorage.getItem('listLanguage')).filter(x => x.id === localStorage.getItem('currentLanguage')).length > 0 ? localStorage.getItem('currentLanguage') : defaultLocale
// const i18n = new VueI18n({
//     locale: locale,
//     fallbackLocale: locale,
//     messages
// })

// Vue.directive('click-outside', {
//     bind: function (el, binding, vnode) {
//         el.clickOutsideEvent = function (event) {
//             // here I check that click was outside the el and his children
//             if (!(el == event.target || el.contains(event.target))) {
//                 // and if it did, call method provided in attribute value
//                 vnode.context[binding.expression](event)
//             }
//         }
//         document.body.addEventListener('click', el.clickOutsideEvent)
//     },
//     unbind: function (el) {
//         document.body.removeEventListener('click', el.clickOutsideEvent)
//     }
// })
// export default new Vue({
//     i18n,
//     router,
//     store,
//     render: h => h(App)
// }).$mount('#app')

const main = async () => {
	const response = await authenAndConfigCustomize.GetByTableName({ TableName: 'V_I18_NLT_INFORMATION' });
	let arr = response.status ? response.data : [];
	let vn = {};
	let en = {};
	arr.forEach((e) => {
		vn = { ...vn, [e.ClName]: e.ShwName };
		en = { ...en, [e.ClName]: e.NameExtention1 };
	});
	const messages = { vn: vn, en: en };
	const locale =
		localStorage.getItem('currentLanguage') &&
			JSON.parse(localStorage.getItem('listLanguage'))?.length > 0 &&
			JSON.parse(localStorage.getItem('listLanguage')).filter((x) => x.id === localStorage.getItem('currentLanguage')).length > 0
			? localStorage.getItem('currentLanguage')
			: defaultLocale;
	const i18n = new VueI18n({
		locale: locale,
		fallbackLocale: locale,
		messages,
	});
	return new Vue({
		i18n,
		router,
		store,
		render: (h) => h(App),
	}).$mount('#app');
};
export default main();
